<template lang="html">
  <div class="page-admin show-cards-in-sequence-- show-cards-up--">
    <div class="row">
    <!--<navbar-component/>-->

    <!--<dashboard-component>-->
      <card-component :col="{xs: 12}">
        <div class="card-inner">
          <h3>Cliente</h3>
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label for="name" class="form-label">Nome</label>
                <input type="text" readonly class="form-control-plaintext" id="name" :value="tx.data.data.buyer.name">
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="cpf" class="form-label">CPF</label>
                <input type="text" readonly class="form-control-plaintext" id="cpf" :value="tx.data.data.buyer.cpf">
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="email" class="form-label">E-mail</label>
                <input type="text" readonly class="form-control-plaintext" id="email" :value="tx.data.data.buyer.email">
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="telefone" class="form-label">Telefone</label> <a :href="'https://api.whatsapp.com/send?phone=55' + tx.data.data.buyer.phoneNumber" target="_blank"><i class="micon-whatsapp"></i></a>
                <input type="text" readonly class="form-control-plaintext" id="telefone" :value="tx.data.data.buyer.phoneNumber">
              </div>
            </div>
          </div>
          <h3>Endereço de Entrega</h3>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="name" class="form-label">Rua, número e complemento</label>
                <input type="text" readonly class="form-control-plaintext" id="name" :value="tx.data.data.shipping.address.street + ', ' + tx.data.data.shipping.address.number + ', ' + tx.data.data.shipping.address.complement">
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="cpf" class="form-label">Cidade/UF</label>
                <input type="text" readonly class="form-control-plaintext" id="cpf" :value="tx.data.data.shipping.address.city">
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="email" class="form-label">CEP</label>
                <input type="text" readonly class="form-control-plaintext" id="email" :value="tx.data.data.shipping.address.zip">
              </div>
            </div>
          </div>
        </div>
      </card-component>
      <card-component :col="{xs: 12}">
        <div class="card-inner">
          <h3>Itens no Carrinho</h3>
          <table class="table table-hover">
            <thead class="thead-light">
            <tr>
              <th scope="col">Qtd</th>
              <th scope="col">Produto</th>
              <th scope="col">SKU</th>
              <th scope="col" class="text-right">Preço unit.</th>
              <th scope="col" class="text-right">Desconto</th>
              <th scope="col" class="text-right">Total</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="i in tx.data.data.cart" v-bind:key="i.id">
              <td scope="row">{{ i.quantity }}</td>
              <td>{{ i.description }}</td>
              <td>{{ i.id }}</td>
              <td class="text-right">{{ i.amount | numeral('$ 0,0.00')  }}</td>
              <td class="text-right">0</td>
              <td class="text-right">{{ i.amount | numeral('$ 0,0.00')  }}</td>
            </tr>
            </tbody>
          </table>
          <h3>Controle financeiro</h3>
          <div class="row">
            <div class="col-6">
              <table class="table table-hover">
                <thead class="thead-light">
                <tr>
                  <th scope="col">Pedido total</th>
                  <th scope="col" class="text-right">R$ {{ tx.data.data.payment.amount }}</th>
                </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Capturado</td>
                    <td class="text-right">R$ 0,00</td>
                  </tr>
                  <tr>
                    <td>Não capturado</td>
                    <td class="text-right">R$ 0,00</td>
                  </tr>
                  <tr>
                    <td>Reembolsado</td>
                    <td class="text-right">R$ 0,00</td>
                  </tr>
                  <tr class="table-secondary">
                    <td><strong>Faturado</strong></td>
                    <td class="text-right"><strong>R$ 0,00</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </card-component>
      <card-component :col="{xs: 12}">
        <div class="card-inner">
          <h3>Financiamento</h3>
        </div>
      </card-component>
      <card-component :col="{xs: 12}">
        <div class="card-inner">
          <h3>Timeline de atividades</h3>
          <div class="container py-2">
            <timeline-component :timeline="timeline"/>
          </div>
        </div>
      </card-component>
    <!--</dashboard-component>-->
    </div>
  </div>
</template>

<script>
import Card from '../../partial/card/Card.vue'
import Navbar from '../../partial/navbar/Navbar.vue'
import Dashboard from '../../partial/dashboard/Dashboard.vue'
import Background from '../../partial/background/Background.vue'
import Input from '../../partial/form/Input.vue'
import Button from '../../partial/button/Button.vue'
import Timeline from '../../partial/timeline/Timeline.vue'

export default {
  components: {
    'card-component': Card,
    'navbar-component': Navbar,
    'dashboard-component': Dashboard,
    'background-component': Background,
    'button-component': Button,
    'input-component': Input,
    'timeline-component': Timeline
  },
  data () {
    return {
      tx: null,
      timeline: null
      // interval: null
    }
  },
  methods: {
    getTransaction () {
      this.$http.get('transactions/' + this.$route.params.txid)
        .then(function (res) {
          this.tx = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getTimeline () {
      this.$http.get('api/transactions/' + this.$route.params.txid + '/timeline')
        .then(function (res) {
          this.timeline = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  mounted () {
    this.getTransaction()
    this.getTimeline()
    // this.interval = setInterval(function () {
    //   this.getTimeline()
    // }.bind(this), 750)
  },
  beforeDestroy: function () {
    // clearInterval(this.interval)
  }
}

</script>

<style lang="css">
  h3 {
    padding-top: 15px;
    padding-bottom: 10px;
    font-size: 22px;
    font-family: "Poppins", sans-serif;
    color: #6E6E6E;
    font-weight: 400;
  }
  .form-label {
    color: #C0C0C0;
    font-size: 14px;
    line-height: 1.2em;
    margin-bottom: 0;
  }
  .form-control-plaintext {
    color: #6E6E6E;
    font-size: 18px;
    padding-top: 0;
  }
  .card-inner {
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 5px;
  }
  .document-image {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/transactions/TransactionDetails.vue